import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Project } from '../../shared/models/project.model';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { FwIconModule, FwTooltipModule } from '@flywheel-io/vision';
import { DirectivesModule } from 'app/src/common/directives.module';
import { ContainerModule } from 'app/src/containers/container.module';
import { FileModule } from 'app/src/files/file.module';
import { MaterialModule } from 'app/src/material.module';
import { PipesModule } from 'app/src/shared/pipes.module';
import { SharedModule } from 'app/src/shared/shared.module';
import { SessionDetailComponent } from './session-detail.component';

@Component({
  host: {
    class: 'mat-dialog-component',
    'test-id': 'session-detail-dialog',
  },
  selector: 'session-detail-dialog',
  template: `
    <button mat-icon-button mat-dialog-close test-id="dialog-close-button" class="mat-dialog-close-button">
      <mat-icon>close</mat-icon>
    </button>
    <mat-dialog-content [class]="{flex: data}">
      <session-detail *ngIf="!data; else projectLink" class="dialog-component"></session-detail>
    </mat-dialog-content>
    <ng-template #projectLink>
      <div class="info-message">
        <div class="fab">
          <mat-icon>error_outline</mat-icon>
        </div>
        <p>
          <span>Result is attached to the project</span>
          <a href="#/projects/{{ data.parentProject._id }}/information">
            {{ data.parentProject.label || data.parentProject._id }}
          </a>
        </p>
      </div>
    </ng-template>

  `,
  styleUrls: ['./session-detail-dialog.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    ContainerModule,
    DirectivesModule,
    DragDropModule,
    FileModule,
    FormsModule,
    FwIconModule,
    FwTooltipModule,
    ReactiveFormsModule,
    MaterialModule,
    PipesModule,
    SharedModule,
    RouterModule,
    SessionDetailComponent,
  ],
})
export class SessionDetailDialog {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { parentProject: Project }
  ) {
  }
}
